var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataUsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.3818 21.1133C12.7367 21.1133 12.2144 21.6433 12.2144 22.2981L11.8926 28.0215C11.8926 28.8558 12.5597 29.5314 13.3818 29.5314C14.204 29.5314 14.8696 28.8558 14.8696 28.0215L14.5492 22.2981C14.5492 21.6433 14.027 21.1133 13.3818 21.1133Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9755 9.59181C14.9755 9.59181 14.6405 9.24737 14.4327 9.09741C14.1314 8.8658 13.7598 8.75 13.3897 8.75C12.9742 8.75 12.588 8.88065 12.2735 9.12711C12.2164 9.18501 11.9736 9.40326 11.7732 9.60666C10.5151 10.7959 8.45674 13.9003 7.82769 15.526C7.72821 15.7725 7.51317 16.3961 7.5 16.7301C7.5 17.0478 7.57022 17.3537 7.71358 17.6432C7.914 18.0054 8.22853 18.2964 8.60011 18.4553C8.85758 18.5577 9.62853 18.7166 9.64316 18.7166C10.4873 18.8769 11.8595 18.9631 13.375 18.9631C14.8189 18.9631 16.1341 18.8769 16.9913 18.7463C17.006 18.7314 17.9627 18.5726 18.2919 18.3974C18.8917 18.0782 19.2647 17.4546 19.2647 16.788V16.7301C19.2501 16.2951 18.877 15.3805 18.8639 15.3805C18.2348 13.8424 16.276 10.8107 14.9755 9.59181Z",
    fill: "#E5B910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.6181 18.887C27.2633 18.887 27.7855 18.357 27.7855 17.7022L28.1059 11.9787C28.1059 11.1443 27.4403 10.4688 26.6181 10.4688C25.796 10.4688 25.1289 11.1443 25.1289 11.9787L25.4507 17.7022C25.4507 18.357 25.973 18.887 26.6181 18.887Z",
    fill: "#E5B910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2855 22.3551C32.0851 21.9928 31.7706 21.7033 31.399 21.5429C31.1415 21.4405 30.3691 21.2816 30.3559 21.2816C29.5118 21.1213 28.1396 21.0352 26.624 21.0352C25.1802 21.0352 23.865 21.1213 23.0077 21.2519C22.9931 21.2668 22.0364 21.4271 21.7072 21.6008C21.106 21.92 20.7344 22.5436 20.7344 23.2117V23.2696C20.749 23.7047 21.1206 24.6177 21.1352 24.6177C21.7643 26.1559 23.7216 29.1891 25.0236 30.4066C25.0236 30.4066 25.3586 30.7511 25.5664 30.8995C25.8663 31.1326 26.2378 31.2484 26.6109 31.2484C27.0249 31.2484 27.4096 31.1178 27.7256 30.8713C27.7827 30.8134 28.0255 30.5952 28.2259 30.3932C29.4826 29.2025 31.5423 26.098 32.1699 24.4737C32.2709 24.2273 32.4859 23.6022 32.4991 23.2696C32.4991 22.9504 32.4289 22.6446 32.2855 22.3551Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUsed);
export default __webpack_public_path__ + "static/media/data-used.ff6ca2dbda823e78f933992bd5182011.svg";
export { ForwardRef as ReactComponent };